module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v1-560.ed11e748.png";